/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Diet_TitleInputs */

const en_platform_view_diet_title = /** @type {(inputs: Platform_View_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's diet`)
};

const pl_platform_view_diet_title = /** @type {(inputs: Platform_View_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta na dziś`)
};

/**
* | output |
* | --- |
* | "Today's diet" |
*
* @param {Platform_View_Diet_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_diet_title = /** @type {((inputs?: Platform_View_Diet_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Diet_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_diet_title(inputs)
	return en_platform_view_diet_title(inputs)
});